
import { observer } from "@legendapp/state/react";
import { useLocation, useNavigate } from "react-router-dom";
import CategoriesEntries, { IItem } from "../../../../components/ui/category-entries/CategoryEntries";
import LoaderContent from "../../../../components/ui/loader-content/LoaderContent";
import { useQueryGetFiles } from "../../../../query/getFiles/useGetFiles.query";
import { overlayState$, pageState$, state$ } from "../../../../state";
import { ReactComponent as ClearIcon } from "./../../../../assets/icons/close-alt.svg";

const SubCategoryContent = observer(() => {

  const { pathname } = useLocation();
  const path = pathname.slice(1);

  const searchState = pageState$.searchState.get();
  const { data, isLoading } = useQueryGetFiles(true, { path: path || '', search: searchState });

  const isFullWidthState = state$.settings.isFullWidthState.get();
  const navigate = useNavigate();

  const currentOverlayActiveId = overlayState$.activeItemId.get();

  if (isLoading) {

    return <div className={`content animated-max-width ${isFullWidthState ? 'container-fluid' : 'container'}`}>
      <div className="row">
        <div className="col">
          <div className="content__wrapper ">
            <LoaderContent />
          </div>
        </div>
      </div>
    </div>
  }

  return (
    <div className={`content animated-max-width ${isFullWidthState ? 'container-fluid' : 'container'}`}>
      <div className="row">
        <div className="col">
          <div className="content__wrapper ">
            {
              searchState && searchState.length ?
                data && data.length ?
                  <div className="search">
                    <h3 className="search__header">
                      Found {data.length} search results for <u>{searchState}</u> keyword
                    </h3>

                    <button type="button"
                      className="search__clear btn btn--reset d-flex"
                      onClick={() => pageState$.searchState.set('')}>
                      <ClearIcon /> Clear Search
                    </button>
                  </div>
                  :
                  <div className="search">
                    <h3 className="search__header">
                      No results found for <u>{searchState}</u> keyword
                    </h3>

                    <button type="button"
                      className="search__clear btn btn--reset d-flex"
                      onClick={() => pageState$.searchState.set('')}>
                      <ClearIcon /> Clear Search
                    </button>
                  </div>
                : null
            }

            <CategoriesEntries
              isDisabled={isLoading || currentOverlayActiveId !== null}
              isLoading={isLoading}
              requestItemClick={handleItemClick}
              items={data || []} />
          </div>
        </div>
      </div>
    </div>
  )

  function handleItemClick(item: IItem) {

    if (item.isFile) {
      overlayState$.activeItemId.set(item.id);
      return;
    }
    overlayState$.activeItemId.set(null);
    navigate({
      pathname: item.name
    })
  }
});

export default SubCategoryContent;
